var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    clipPath: "url(#clip0_13476_99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.73676 4.68005L9.16405 11.6513C9.38095 12.7102 10.4451 13.3864 11.541 13.161L17.7636 11.8842C18.8595 11.6593 19.5724 10.6188 19.356 9.55992L17.9288 2.58867C17.7118 1.5298 16.6477 0.853573 15.5518 1.07898L9.32922 2.3558C8.23325 2.58071 7.52036 3.62117 7.73676 4.68005Z",
    fill: "#FFA586"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.53069 7.53807L8.27129 14.779C8.83942 15.8787 10.2587 16.2738 11.4413 15.6617L18.1548 12.1856C19.3374 11.573 19.8353 10.1853 19.2672 9.08558L15.5266 1.84464C14.9585 0.744961 13.5392 0.349874 12.3566 0.96191L5.64307 4.43808C4.46055 5.05062 3.96256 6.4384 4.53069 7.53807Z",
    fill: "#B51A2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.911494 13.2997L8.17429 20.0276C9.27721 21.0497 11.1343 20.8362 12.3218 19.5514L19.0628 12.2577C20.2503 10.9729 20.3184 9.10299 19.2155 8.08094L11.9527 1.35301C10.8498 0.330962 8.99265 0.544428 7.80515 1.82921L1.06422 9.1229C-0.123276 10.4077 -0.191431 12.2776 0.911494 13.2997Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.8702 13.2708H11.7324C10.8902 13.2564 10.4395 13.2599 10.4395 12.3552V6.66977C10.4395 6.66977 10.4564 6.416 10.1708 6.416C9.76935 6.41351 9.36837 6.4145 8.9669 6.4145C8.76492 6.4145 8.63657 6.50357 8.63657 6.66678C8.63657 6.85636 8.63309 7.04545 8.62662 7.23503C8.60075 7.9854 8.49578 8.53374 7.77144 8.59296C7.60827 8.60639 7.41723 8.59495 7.24908 8.59495C7.08093 8.59495 6.98193 8.69347 6.98193 8.84772V9.94939C6.98193 10.0937 7.06452 10.1892 7.21625 10.2012L8.21968 10.2027C8.23112 11.0132 8.2162 11.8328 8.2162 12.6443C8.25599 13.223 8.35748 13.746 8.5913 14.0774C9.35196 15.1562 10.6499 14.9362 11.8707 14.9661C12.0438 14.9701 12.1379 14.8447 12.1379 14.6541V13.5828C12.1379 13.3922 12.0438 13.2708 11.8707 13.2708H11.8702Z",
    fill: "#0F162C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.1476 8.4458C11.566 8.4458 11.1382 8.8384 11.1382 9.38724C11.1382 9.93609 11.5655 10.3292 12.1476 10.3292C12.7296 10.3292 13.145 9.91419 13.145 9.38724C13.145 8.86029 12.7416 8.4458 12.1476 8.4458Z",
    fill: "#0F162C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13476_99"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.8731,
    height: 20,
    fill: "white",
    transform: "translate(0.126953 0.673828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.e2409bc77c576bc83184b5a76809b818.svg";
export { ForwardRef as ReactComponent };